import { defineFeature } from "../core/composition/define-feature.js";
import { getResolvedSelectedTrackDuration } from "../media/utils/track-selection.js";
import { calculatePresentationDuration } from "../behaviors/calculate-presentation-duration.js";
//#region src/playback/features/calculate-duration.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [calculatePresentationDuration];
/** The config defaults the feature contributes. */
const defaultConfig = { resolveDuration: getResolvedSelectedTrackDuration };
/** The state values the feature seeds. */
const initialState = {};
/**
* Calculates the presentation's duration from its selected tracks once they've loaded.
*
* Requires a writer of resolved, selected video or audio tracks, such as `videoFeature` or `audioFeature`; without one,
* no duration is set.
*/
const calculateDurationFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, calculateDurationFeature, defaultConfig, initialState };

//# sourceMappingURL=calculate-duration.js.map